import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  cartItemsCount?: number;
}

const Layout: React.FC<LayoutProps> = ({ children, cartItemsCount }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh',pt:0 }}>
      <Header cartItemsCount={cartItemsCount || 0} />
      <Box component="main" sx={{ flexGrow: 1, mb: 4 }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
